import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5 14.62C5 18.52 8.163 22 12.38 22s7.38-3.48 7.38-7.38c0-2.25-.768-3.732-1.649-5.43q-.227-.434-.459-.896c-.591-1.183-2.176-3.995-3.455-6.237-.803-1.409-2.824-1.41-3.628-.002-1.28 2.242-2.87 5.056-3.46 6.239a66 66 0 0 1-.46.896C5.77 10.888 5 12.37 5 14.62m12.125.086a1.054 1.054 0 1 0-2.109 0c0 1.527-1.11 2.636-2.636 2.636a1.054 1.054 0 1 0 0 2.109c2.691 0 4.745-2.054 4.745-4.745",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_fuel_filled-DcGebeo4.js.map
